import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Play =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTguNjYsMy4xOFYxNi4zOWEuNjEuNjEsMCwwLDEtLjYuNkgzLjI1YS42MS42MSwwLDAsMS0uNi0uNlYzLjE4YS42MS42MSwwLDAsMSwuNi0uNkg4LjA2YS42MS42MSwwLDAsMSwuNi42Wm04LjQxLDBWMTYuMzlhLjYxLjYxLDAsMCwxLS42LjZIMTEuNjdhLjYxLjYxLDAsMCwxLS42LS42VjMuMThhLjYxLjYxLDAsMCwxLC42LS42aDQuODFhLjYxLjYxLDAsMCwxLC42LjZaIi8+PC9zdmc+'
const Pause =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggIGQ9Ik0xNi42NCw5Ljg4LDQuMTgsMTYuODFhLjM1LjM1LDAsMCwxLS4zNywwLC4zNi4zNiwwLDAsMS0uMTUtLjM0VjIuNjhhLjM2LjM2LDAsMCwxLC4xNS0uMzQuMzUuMzUsMCwwLDEsLjM3LDBMMTYuNjQsOS4zYS4zLjMsMCwwLDEsMCwuNThaIi8+PC9zdmc+'

const PlayButton = styled.button`
  position: absolute;
  bottom: -10px;
  right: -7px;
  border-radius: 50%;
  min-width: initial;
  width: 24px;
  height: 24px;
  padding: 8px;
  background-color: #bdbdbd;
  text-indent: -1000px;
  background-size: 70%;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  background-image: url(${({ isPaused }) => (isPaused ? Pause : Play)});
`

const TogglePlayButton = ({ isPaused, onHandleToggle }) => (
  <PlayButton
    name="toggle-animation"
    isPaused={isPaused}
    onClick={() => onHandleToggle()}
  >
    {isPaused ? 'Pause' : 'Play'}
  </PlayButton>
)

TogglePlayButton.propTypes = {
  isPaused: PropTypes.bool,
  onHandleToggle: PropTypes.func.isRequired,
}

export default TogglePlayButton
